<template>
  <div>
    <div v-if="loadingList">
      <AppSkeletonCardField :cols="4" :rows="1"></AppSkeletonCardField>
    </div>
    <div v-else class="p-grid" v-for="result in results" :key="result.id">
      <div class="p-col-12">
        <a href="#">
          <VetCustomerCard :model="result" @click="showEdit(result)" />
        </a>
      </div>
    </div>
    <div>
      <VetDialog
        v-model:visible="modalVisible"
        :initialData="modalData"
        @accept="fetchList()"
        @remove="fetchList()"
      ></VetDialog>
    </div>
  </div>
</template>

<script>
import useApiList from '../../lib/useApiList';
import { VetCustomerApi } from '../../services/api';
import VetCustomerCard from './components/VetCustomerCard.vue';
import VetDialog from './components/VetDialog.vue';

export default {
  name: 'VetList',
  components: {
    VetCustomerCard,
    VetDialog,
  },
  setup() {
    const apiList = useApiList(VetCustomerApi);
    return { ...apiList };
  },
  data() {
    return {
      modalVisible: false,
      modalData: null,
    };
  },
  async created() {
    await this.fetchList();
  },
  methods: {
    showAdd() {
      this.modalVisible = true;
      this.modalData = null;
    },
    showEdit(data) {
      this.modalVisible = true;
      this.modalData = data;
    },
  },
};
</script>

<style lang="css" scoped>
#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>
